var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15805_142441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 6.66732H14.1673V5.00065C14.1673 2.70065 12.3007 0.833984 10.0007 0.833984C7.70065 0.833984 5.83398 2.70065 5.83398 5.00065H7.50065C7.50065 3.61732 8.61732 2.50065 10.0007 2.50065C11.384 2.50065 12.5007 3.61732 12.5007 5.00065V6.66732H5.00065C4.08398 6.66732 3.33398 7.41732 3.33398 8.33398V16.6673C3.33398 17.584 4.08398 18.334 5.00065 18.334H15.0007C15.9173 18.334 16.6673 17.584 16.6673 16.6673V8.33398C16.6673 7.41732 15.9173 6.66732 15.0007 6.66732ZM15.0007 16.6673H5.00065V8.33398H15.0007V16.6673ZM10.0007 14.1673C10.9173 14.1673 11.6673 13.4173 11.6673 12.5007C11.6673 11.584 10.9173 10.834 10.0007 10.834C9.08398 10.834 8.33398 11.584 8.33398 12.5007C8.33398 13.4173 9.08398 14.1673 10.0007 14.1673Z",
    fill: "#303238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15805_142441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock_open.bfc9c5f56ea5e209cf892c511e39acea.svg";
export { ForwardRef as ReactComponent };